import { render, staticRenderFns } from "./list-history.vue?vue&type=template&id=4df94476&scoped=true"
import script from "./list-history.vue?vue&type=script&lang=js"
export * from "./list-history.vue?vue&type=script&lang=js"
import style0 from "./list-history.vue?vue&type=style&index=0&id=4df94476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df94476",
  null
  
)

export default component.exports